module.exports = __webpack_public_path__ + "static/media/Daphne Chen.11eb7d96.png";